import { ThrottleButton } from '@eastcoal/common/components/Button/ThrottleButton'
import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'
import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'

import { useCertificationsStore } from '../../Store/hooks/useStore'

export const OkButton = () => {
  const { mode, submit } = useCrudFormStore(state =>
    pick(state, ['mode', 'submit'])
  )
  const toggleCertificationFormVisible = useCertificationsStore(
    state => state.toggleCertificationFormVisible
  )
  const onOk = async () => {
    await submit()
    toggleCertificationFormVisible()
  }

  return mode !== FormMode.READ ? (
    <ThrottleButton type='primary' onClick={onOk}>
      确定
    </ThrottleButton>
  ) : null
}
